// extracted by mini-css-extract-plugin
export var cardLayout = "_6f-1";
export var paginationContainer = "_6f-0";